import "./bulk-tender-toolbar.css";

import { Button } from "@tql/ui-components-react/tql/buttons";
import {
	arrowRight,
	refreshCcw_01,
} from "@tql/ui-components-react/untitled/icons";

type BulkTenderToolbarProps = {
	selectedCount: number;
	onTenderShipments: () => void;
	onRequote?: () => void;
	rerateDisabled?: boolean;
	rerateTitle?: string;
	isRequoting?: boolean;
	tenderDisabled?: boolean;
};

export const BulkTenderToolbar = ({
	selectedCount,
	onTenderShipments,
	onRequote,
	rerateDisabled = false,
	rerateTitle,
	isRequoting = false,
	tenderDisabled = false,
}: BulkTenderToolbarProps) => {
	const showCount = !isRequoting && selectedCount > 0;

	return (
		<div
			aria-label={"Bulk Tender actions"}
			className={"bulk-tender-toolbar"}
			role={"toolbar"}
		>
			<Button
				disabled={selectedCount === 0 || isRequoting || tenderDisabled}
				onClick={onTenderShipments}
				svgIcon={arrowRight}
				variant={"primary"}
			>
				Tender Shipments
			</Button>
			{showCount ? (
				<span aria-live={"polite"} className={"bulk-tender-toolbar-count"}>
					{selectedCount} selected
				</span>
			) : null}
			<Button
				disabled={
					onRequote == null ||
					rerateDisabled ||
					isRequoting ||
					selectedCount !== 1
				}
				onClick={onRequote}
				svgIcon={refreshCcw_01}
				title={rerateTitle ?? "Select exactly one shipment to requote"}
				variant={"secondary"}
			>
				Requote
			</Button>
		</div>
	);
};
